import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DatePicker as AntdDatePicker } from 'antd';
import moment from 'moment';
import {CalendarIcon} from '../../../assets/icons'
import { View } from '../View';
import Text from '../Text';

import { styleUtils } from '../../utils';

import styles from './styles';

const { style } = styleUtils;

const Container = style(View, styles.container);
const Label = style(Text, styles.label);
const Sublabel = style(Text, styles.sublabel);
const Rightlabel = style(Text);
const DatepickerContainer = style(View, styles.datepickerContainer);
const SDatepicker = style(AntdDatePicker, styles.datepicker);
const SMessage = style(Text, styles.message);

const DATE_FORMAT = 'YYYY/MM/DD';

const DISABLED_DATES = {
  beforeToday: current => current && current < moment().endOf('day')
};

class Datepicker extends Component {
  render() {
    const {
      defaultValue,
      defaultPickerValue,
      placeholder,
      onChange,
      required,
      label,
      sublabel,
      datesDisabled,
      error,
      message,
      rightLabel,
      onOpen,
      ...restOfProps
    } = this.props;

    return (
      <Container onClick={onOpen}>
        {label && (
          <Label weight="900" required={required}>
            {label}
          </Label>
        )}
        {sublabel && <Sublabel size="small">{sublabel}</Sublabel>}
        <DatepickerContainer>
          <SDatepicker
            onChange={onChange}
            defaultValue={defaultValue}
            defaultPickerValue={defaultValue || defaultPickerValue}
            format={DATE_FORMAT}
            suffixIcon={<CalendarIcon/>}
            placeholder={placeholder}
            disabledDate={
              datesDisabled ? DISABLED_DATES[datesDisabled] : undefined
            }
            error={error}
            {...restOfProps}
          />
          {rightLabel && <Rightlabel size="small">{rightLabel}</Rightlabel>}
        </DatepickerContainer>
        <Message message={message} error={error} />
      </Container>
    );
  }
}

const Message = ({ message, error }) =>
  message ? (
    <SMessage error={error} size="small">
      {message}
    </SMessage>
  ) : null;

Datepicker.propTypes = {
  defaultValue: PropTypes.objectOf(moment),
  defaultPickerValue: PropTypes.objectOf(moment),
  onChange: PropTypes.func,
  onOpen: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.string,
  sublabel: PropTypes.string,
  datesDisabled: PropTypes.oneOf(Object.keys(DISABLED_DATES)),
  error: PropTypes.bool,
  message: PropTypes.string,
  rightLabel: PropTypes.string
};

Datepicker.defaultProps = {
  defaultValue: null,
  defaultPickerValue: moment(),
  placeholder: DATE_FORMAT.toLowerCase()
};

export default Datepicker;
